import { enhancedApi } from '@store/generated/documents';

/**
 * Feature-specific tag types for documents
 */
const DOCUMENTS_TAG_TYPES = ['Document', 'DocumentList'] as const;

/**
 * Documents API - extends the generated API with custom tagging
 */
export const documentsApi = enhancedApi.enhanceEndpoints({
  addTagTypes: DOCUMENTS_TAG_TYPES,
  endpoints: {
    // Provider documents list
    getV2ProviderDocuments: {
      providesTags: result =>
        result
          ? [
              ...result.items.map(item => ({
                type: 'Document' as const,
                id: item.document_id,
              })),
              { type: 'DocumentList' as const, id: 'LIST' },
            ]
          : [{ type: 'DocumentList', id: 'LIST' }],
    },
    // Single document by ID
    getV2ProviderDocumentsByDocumentId: {
      providesTags: (_result, _error, arg) => [{ type: 'Document' as const, id: arg.documentId }],
    },
    // Create document for encounter
    postV2ProviderEncountersByEncounterIdDocuments: {
      invalidatesTags: [{ type: 'DocumentList', id: 'LIST' }],
    },
    // Update document
    patchV2ProviderEncountersByEncounterIdDocumentsAndDocumentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Document' as const, id: arg.documentId },
        { type: 'DocumentList', id: 'LIST' },
      ],
    },
    // Delete document
    deleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentId: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Document' as const, id: arg.documentId },
        { type: 'DocumentList', id: 'LIST' },
      ],
    },
    // Generate and send document
    postV2ProviderDocumentsGenerateAndSend: {
      invalidatesTags: [{ type: 'DocumentList', id: 'LIST' }],
    },
  },
});

// Export hooks with user-friendly names
export const {
  useGetV2ProviderDocumentsQuery: useGetDocumentsQuery,
  useGetV2ProviderDocumentsByDocumentIdQuery: useGetDocumentQuery,
  useLazyGetV2ProviderDocumentsByDocumentIdQuery: useLazyGetDocumentQuery,
  usePostV2ProviderEncountersByEncounterIdDocumentsMutation: useCreateDocumentMutation,
  usePatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdMutation:
    useUpdateDocumentMutation,
  useDeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdMutation:
    useDeleteDocumentMutation,
  usePostV2ProviderDocumentsGenerateAndSendMutation: useGenerateAndSendDocumentMutation,
} = documentsApi;

